import { render, staticRenderFns } from "./ThemeCheckboxes.vue?vue&type=template&id=d94bf05c"
import script from "./ThemeCheckboxes.vue?vue&type=script&lang=js"
export * from "./ThemeCheckboxes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports